// import Vue from 'vue'
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import common from '@/utils/common'
import { isWhiteList } from '@/utils/common'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.BASE_API,
  // 超时
  timeout: 50 * 1000
})
let resetToken = true

// request拦截器
service.interceptors.request.use(config => {
  config.headers['Client'] = 'crowd_web'
  if (getToken()) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token
  }

  // 请求映射params参数
  if (config.params) {
    config.params = JSON.parse(JSON.stringify(config.params))
    Object.keys(config.params).forEach(element => {
      // 数据为空重置为undefined
      if (typeof config.params[element] === 'string') {
        const el = config.params[element].trim()
        if (el === '') {
          config.params[element] = undefined
        } else {
          // string 数据去除首位空格
          config.params[element] = el
        }
      } else if (config.params[element] instanceof Array) {
        // 数组转换为字符串
        config.params[element] = config.params[element].join(',')
      }
    })
  }

  // 预定时间大于当前时间进行获取tocken
  if (resetToken && common.localGetKey('time') && common.localGetKey('time') < new Date().getTime()) {
    resetToken = false
    store.dispatch('ChangeTocken').then(() => {
      resetToken = true
    }).catch(() => {
      resetToken = true
    })
  }
  return config
}, error => {
  // Do something with request error
  console.log(error)
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(res => {
  // 二进制数据则直接返回
  if (res.config.responseType === 'blob' || res.config.responseType === 'arraybuffer') {
    return res.data
  }

  // 参数中存在 baiduApi 认为是百度地图
  if (res && res.config && res.config.params && res.config.params.requestType === 'baiduApi') {
    return res.data
  }

  // oss/算法接口则直接返回
  if (res.request.responseURL.indexOf('oss') !== -1 || res.request.responseURL.indexOf('identifyImage') !== -1) {
    return res.data
  }

  // 未设置状态码则默认成功状态
  const code = res.data.status || 200
  // 获取错误信息
  const msg = common.getMsg(code, (res.data.message || '操作失败'))

  // Token非法 8405 ,8403 禁用 8414 登录信息失效
  if (code === 401 || code === 8405 || code === 8403 || code === 8414) {
    MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示',
      {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }
    ).then(() => {
      store.dispatch('FedLogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }).catch(() => {
      store.dispatch('FedLogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    })
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
  } else if (res.status !== 200 || code !== 200) {
    const resConfig = res.config
    const resCode = res.status !== 200 ? res.status : code
    if (isWhiteList(resConfig, resCode)) {
      return res.data
    }
    Message({ message: msg, type: 'error', duration: 5 * 1000 })
    return Promise.reject('error')
  } else {
    return res.data
  }
}, error => {
  console.log(error)
  Message({
    message: common.getMsg(error.response.data.status) === '操作失败' ? error.message : common.getMsg(error.response.data.status),
    type: 'error',
    duration: 5 * 1000
  })
  // Vue.prototype.$throw(error)
  return Promise.reject(error)
}
)

export default service
